import {Component, OnInit, Input, SimpleChanges, OnChanges} from "@angular/core";
import { EventLogShowService } from '../../services/event-log-show.service';
import { EventLog } from '../../dto/event-log';
import {CustomersService} from '../../home/services/customers.service';
import {CustomerEmailLogDto} from '../../dto/customer-email-log-dto';
import {Severity} from "../../dto/object-comment";
import {toDateTimeStringNoSeconds} from "../../providers/app-date-adapter";

@Component({
  selector: 'app-customer-email-log-view',
  templateUrl: './customer-email-log-view.component.html',
  styleUrls: ['./customer-email-log-view.component.css']
})
export class CustomerEmailLogViewComponent implements OnInit, OnChanges {
  @Input() logs: CustomerEmailLogDto[];

  //logs: CustomerEmailLogDto[];


  constructor(
    public customerService: CustomersService
  ) { }


  readonly typeNames = new Map<number, string>([
    [0, 'Other'],
    [1, 'Ident Reminder'],
    [2, 'Idv'],
    [3, 'Docs'],
    [4, 'Payment reminder'],
    [5, 'Card activation'],
    [6, 'CashBro'],
    [7, 'Invoice'],
    [8, 'Shipped e-mail'],
    [9, 'Other order status'],
    [10, 'Card in production'],
    [11, 'Card shipped'],
    [12, 'Cancellation'],
    [13, 'Order welcome'],
    [14, 'Address'],
    [15, 'Manual SMS'],
    [16, 'SOF generic'],
    [17, 'SOF single'],
    [18, 'Manual Push'],
    [19, 'Address confirmation'],
    [20, 'Automatic Push'],

  ]);

  /*

  {{ log.emailType == 0 ? 'Other' : '' }}
                {{ log.emailType == 1 ? 'Ident Reminder' : '' }}
                {{ log.emailType == 2 ? 'Idv' : '' }}
                {{ log.emailType == 3 ? 'DOCs' : '' }}
                {{ log.emailType == 4 ? 'Payment reminder' : '' }}
                {{ log.emailType == 5 ? 'Card activation' : '' }}
                {{ log.emailType == 6 ? 'CashBro' : '' }}
                {{ log.emailType == 7 ? 'Invoice' : '' }}
                {{ log.emailType == 8 ? 'Shipped e-mail' : '' }}
                {{ log.emailType == 9 ? 'Other order status' : '' }}
                {{ log.emailType == 10 ? 'Card in production' : '' }}
                {{ log.emailType == 11 ? 'Card shipped' : '' }}
                {{ log.emailType == 12 ? 'Cancellation' : '' }}
                {{ log.emailType == 13 ? 'Order welcome' : '' }}
                {{ log.emailType == 14 ? 'Address' : '' }}
                {{ log.emailType == 15 ? 'Manual SMS' : '' }}
                {{ log.emailType == 16 ? 'SOF Generic' : '' }}
                {{ log.emailType == 17 ? 'SOF Single' : '' }}
                {{ log.emailType == 18 ? 'Manual Push' : '' }}
                {{ log.emailType == 19 ? 'Address Confirmation' : '' }}
                {{ log.emailType == 20 ? 'Automatic Push' : '' }}

   */


  readonly typeColors = new Map<Severity, string>([

    [0, 'grey'],
    [1, '#0492c2'],
    [2, '#0492c2'],
    [3, '#0492c2'],
    [4, '#ec9706'],
    [5, '#8bc34a'],
    [6, '#ec9706'],
    [7, '#c2d350'],
    [8, '#8bc34a'],
    [9, '#48beb5'],
    [10, '#8bc34a'],
    [11, '#8bc34a'],
    [12, '#ec9706'],
    [13, '#8bc34a'],
    [14, '#0492c2'],
    [15, '#844ac3'],
    [16, '#0492c2'],
    [17, '#0492c2'],
    [18, '#844ac3'],
    [19, '#0492c2'],
    [20, '#9556da'],

  ]);

  readonly typeIcons = new Map<Severity, string>([
    [0, 'chat_bubble_outline'],
    [1, 'assignment_late'],
    [2, 'fingerprint'],
    [3, 'fingerprint'],
    [4, 'assignment_late'],
    [5, 'grade'],
    [6, 'assignment_late'],
    [7, 'receipt'],
    [8, 'grade'],
    [9, 'label'],
    [10, 'label'],
    [11, 'label'],
    [12, 'thumb_down'],
    [13, 'thumb_up'],
    [14, 'home'],
    [15, 'phonelink_ring'],
    [16, 'money'],
    [17, 'money'],
    [18, 'stay_current_portrait'],
    [19, 'home'],
    [20, 'stay_current_portrait'],
  ]);

  ngOnInit() {
    this.categorizeLogs();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.logs) {
      this.categorizeLogs();
    }
  }


  categorizedLogs: CategorizedLogs  = {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: [],
    thisMonth: [],
    lastMonth: [],
    thisYear: [],
    lastYear: [],
    longAgo: []
  };

  categorizeLogs() {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfToday.getDate() - 1);
    const startOfThisWeek = new Date(startOfToday);
    startOfThisWeek.setDate(startOfToday.getDate() - startOfToday.getDay() + (startOfToday.getDay() === 0 ? -6 : 1)); // ISO week starts on Monday
    const startOfLastWeek = new Date(startOfThisWeek);
    startOfLastWeek.setDate(startOfThisWeek.getDate() - 7);
    const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const startOfLastMonth = new Date(startOfThisMonth);
    startOfLastMonth.setMonth(startOfThisMonth.getMonth() - 1);
    const startOfThisYear = new Date(now.getFullYear(), 0, 1);
    const startOfLastYear = new Date(startOfThisYear);
    startOfLastYear.setFullYear(startOfThisYear.getFullYear() - 1);

    this.categorizedLogs = {
      today: [],
      yesterday: [],
      thisWeek: [],
      lastWeek: [],
      thisMonth: [],
      lastMonth: [],
      thisYear: [],
      lastYear: [],
      longAgo: []
    };

    this.logs.forEach(log => {
      const logDate = new Date(log.creationDate);

      if (logDate >= startOfToday) {
        this.categorizedLogs.today.push(log);
      } else if (logDate >= startOfYesterday && logDate < startOfToday) {
        this.categorizedLogs.yesterday.push(log);
      } else if (logDate >= startOfThisWeek) {
        this.categorizedLogs.thisWeek.push(log);
      } else if (logDate >= startOfLastWeek && logDate < startOfThisWeek) {
        this.categorizedLogs.lastWeek.push(log);
      } else if (logDate >= startOfThisMonth) {
        this.categorizedLogs.thisMonth.push(log);
      } else if (logDate >= startOfLastMonth && logDate < startOfThisMonth) {
        this.categorizedLogs.lastMonth.push(log);
      } else if (logDate >= startOfThisYear) {
        this.categorizedLogs.thisYear.push(log);
      } else if (logDate >= startOfLastYear && logDate < startOfThisYear) {
        this.categorizedLogs.lastYear.push(log);
      } else {
        this.categorizedLogs.longAgo.push(log);
      }
    });
  }



  /**
   * Get additional info for the log body like creation date and e-mail address of the user
   *
   * @param log
   */
  getLogInfo(log: CustomerEmailLogDto): string {

    let recipientPart = " => " + log.emailAddress;

    if (!log.creationDate && !log.creator)
      return recipientPart;

    let datePart: string = toDateTimeStringNoSeconds(log.creationDate);

    let userPart: string = (log.creator?.firstName?.charAt(0) ?? '') +
      (log.creator?.lastName?.charAt(0) ?? '') +
      (log.creator?.firstName || log.creator?.lastName ? " (" : '') +
      (log.creator?.email ?? '') +
      (log.creator?.firstName || log.creator?.lastName ? ')' : '');

    return datePart + (log.creationDate && log.creator ? ", " : '') + userPart + recipientPart;
  }


}

export interface CategorizedLogs {
  today: CustomerEmailLogDto[];
  yesterday: CustomerEmailLogDto[];
  thisWeek: CustomerEmailLogDto[];
  lastWeek: CustomerEmailLogDto[];
  thisMonth: CustomerEmailLogDto[];
  lastMonth: CustomerEmailLogDto[];
  thisYear: CustomerEmailLogDto[];
  lastYear: CustomerEmailLogDto[];
  longAgo: CustomerEmailLogDto[];
}
